export default __webpack_public_path__ + "ec66fae635c2fd6b4eaf0c039414795e.png";